/**
 * RU on all settings including whitelisting
 * This is in common as all apps would need it
 * Setting Key value pairs come from db of the app.
 */
 import { Entity } from '../common/base/entity/entity'
 import { methodSchemas, entitySchema, collectionSchemas } from './category.schema'
 import {ContentActions }from './ContentActions'
 import {CategoryComponent} from '../appComponent'
 /**
  * Instructions: 
  * 1. For simple usage steps:
  * a. fieldsMeta, actionsMeta, screens, sectionsMeta definition and creation of BaseEntity obj with these inputs
  * 2. For simple overrides of baseEntity 
  * a. create an extended class of baseEntity and override its methods...
  * 3. For more customization
  * a. create a derived Service, derived actions and use them in derived BasedEntity class.
  * b. for component customization pass those components to the constuctor of derived BaseEntity class. SearchList component is the root component.
  *
  * 
  */
 
 
 class HierarchyEntity extends Entity {
     // override the following if needed.
     // derived actionObj
     // derived Service obj
     // getActionFns if you want to suppress the baseActionobj methods
    
 }
 
 const fieldsMeta = {
    name: {
        label: 'Label',
        name: 'label',
        type: 'text',
        placeholder:'Enter New Label',
        required:true
    }
}
 
const categoriesMeta = {
    addModal:{
        name: null,
        label:'label',
        level:0,
        parentName:'parentname',
        status:'Published',

    }
} 

 const actionsMeta = {}
 const sectionsMeta = {
     appComponent:{
         title:"appComponent",
         items:[{name:"appComponent", type:"appComponent"}]
       }
 }
 
 
 const appComponentMeta={
     staticContent:{
     contentType:'Category',
     component : 'CategoryComponent',
     content:[{
         name:'CategoryGet',
         title:"CategoryGet",
         api:{
             path:'ticketing/Category',
             method:'GET', 
             entityName:'Category', 
             filter:[{name:'status', value:'Published'}],
         }
          
   
     }, {
         name:'CategoryUpsert',
         title:"CategoryUpsert",
         api:{
             path:'ticketing/Category/upsert',
             method:'POST', 
             entityName:'Category'
         }
   
     }
 ]               
 }
 }
 
 
 
 
 
 
 const screens = {
     view: {},
     create:{},
     edit:{},
     list: {
         type:"appComponent",
         hideList:true,
         multiselect:false,
     }
 }
 // const components = { searchList: EntityComponent} // can overrides the components like this if needed
 const category = new HierarchyEntity({ fieldsMeta, actionsMeta, sectionsMeta, appComponentMeta, screens,ActionClass: ContentActions, name: 'Category', methodSchemas, collectionSchemas, contentMeta:categoriesMeta,  entitySchema, bKeys: ['id'], entityUrlPaths:{update: "ticketing/Category", getAll:"ticketing/Category/findAndCountAll",  default: "ticketing/Category" }, fetchDetailByApi: false, appComponent:CategoryComponent })
 
 const CategoryContainer = category.getContainer('AppComponent')
 
 
 export { CategoryContainer }